import { Typography } from '@breetometer/components';
import { CountDownTimer } from 'BreetComponents';

import type { IWalletGenerationCountDown } from '../EmptyWalletAddress.helpers';

const WalletGenerationCountDown = ({
	onCountDownComplete,
	startCountdown,
	countdownDuration,
	countDownId,
	title,
}: IWalletGenerationCountDown) => (
	<div className='walletgenerationcountdown'>
		<Typography
			as='h1'
			className='color-neutral-50'
		>
			{title}
		</Typography>
		<CountDownTimer
			format='ss'
			onComplete={onCountDownComplete}
			duration={countdownDuration}
			start={startCountdown}
			persistCountDown
			countDownId={countDownId}
		/>
		<Typography
			as='p'
			className='color-primary-50'
		>
			Your wallet address is being generated. Please wait…
		</Typography>
	</div>
);

export default WalletGenerationCountDown;
